import type { CreditBalance, PlanTier } from "@ratsnest/shared";
import { create } from "zustand";

interface CreditState extends CreditBalance {
  isLoaded: boolean;
  isLow: boolean;

  setBalance: (balance: CreditBalance) => void;
  updateFromWs: (payload: {
    creditsRemaining: number;
    creditsIncluded: number;
    periodStart: string;
    periodEnd: string;
  }) => void;
  setLow: (isLow: boolean) => void;
  clear: () => void;
}

const LOW_CREDIT_FRACTION = 0.2;

export const useCreditStore = create<CreditState>()((set) => ({
  plan: "free" as PlanTier,
  creditsRemaining: 0,
  creditsIncluded: 0,
  periodStart: "",
  periodEnd: "",
  isLoaded: false,
  isLow: false,

  setBalance: (balance) =>
    set({
      ...balance,
      isLoaded: true,
      isLow:
        balance.creditsRemaining <=
        Math.ceil(balance.creditsIncluded * LOW_CREDIT_FRACTION),
    }),

  updateFromWs: (payload) =>
    set((state) => ({
      creditsRemaining: payload.creditsRemaining,
      creditsIncluded: payload.creditsIncluded,
      periodStart: payload.periodStart,
      periodEnd: payload.periodEnd,
      isLow:
        payload.creditsRemaining <=
        Math.ceil(payload.creditsIncluded * LOW_CREDIT_FRACTION),
      isLoaded: state.isLoaded,
    })),

  setLow: (isLow) => set({ isLow }),

  clear: () =>
    set({
      plan: "free",
      creditsRemaining: 0,
      creditsIncluded: 0,
      periodStart: "",
      periodEnd: "",
      isLoaded: false,
      isLow: false,
    }),
}));
